import React, { useState } from "react";
import TicketManagementConfirmationContact from "./Common/TicketManagementConfirmationContact";
import VoidConfirmationHeader from "./Void/VoidConfirmationHeader";
import VoidConfirmaionSecondaryHeader from "./Void/VoidConfirmaionSecondaryHeader";
import VoidConfirmationRequestProgress from "./Void/VoidConfirmationRequestProgress";
import VoidConfirmationOrderIdContainer from "./Void/VoidConfirmationOrderIdContainer";
import VoidConfimationPricingSection from "./Void/VoidConfimationPricingSection";
import VoidConfirmationFlightDetails from "./Void/VoidConfirmationFlightDetails";
import VoidConfirmationPassengers from "./Void/VoidConfirmationPassengers";
import VoidConfirmationRemarks from "./Void/VoidConfirmationRemarks";
import TicketManagementConfirmationFareRules from "./Common/TicketManagementConfirmationFareRules";

function TicketManagementFlightVoidConfirmationPage() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState();

  return (
    <div className="w-full flex flex-col items-center bg-background min-h-screen">
      <div className="flex flex-col w-full max-w-7xl items-center pb-10">
        <div
          className={`w-full flex flex-col items-center max-w-7xl gap-4 mt-4 px-3 lg:px-6 py-6 `}
        >
          <VoidConfirmationHeader
            data={data}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
          />
          {loading ? (
            <div className="w-full py-4 flex items-center justify-center">
              <div className="primaryLoader"></div>
            </div>
          ) : (
            <div className="flex flex-col w-full">
              <VoidConfirmaionSecondaryHeader data={data} />
              {/* <VoidConfirmationTakeActionAlert data={data} /> */}
              <VoidConfirmationRequestProgress data={data} />
              <div className="flex w-full gap-4 lg:gap-6 flex-col lg:flex-row relative">
                <div className="flex flex-col flex-1">
                  <VoidConfirmationOrderIdContainer data={data} />
                  <div className="w-full flex lg:hidden">
                    <VoidConfimationPricingSection data={data} />
                  </div>
                  <VoidConfirmationFlightDetails data={data} />
                  <TicketManagementConfirmationFareRules data={data} />
                  <VoidConfirmationPassengers data={data} />
                  <TicketManagementConfirmationContact />
                  <VoidConfirmationRemarks />
                </div>
                <div className="lg:max-w-[350px] w-full hidden lg:flex">
                  <VoidConfimationPricingSection data={data} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TicketManagementFlightVoidConfirmationPage;
